import React, { Component } from "react";
import MotionHomepage from "../../containers/motion/MotionHomepage";
import Team from "../../containers/team/Team";
import Skills from "../../containers/skills/Skills";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";

class Home extends Component {
  render() {
    return (
      <div>
        <MotionHomepage theme={this.props.theme} />
        <Team theme={this.props.theme} />
        <Skills theme={this.props.theme} />
        <Footer theme={this.props.theme} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Home;
